import { fetchWithAuth } from "@/providers/auth-provider";
import { ServiceResponse } from "@/types/services";
import { SetCollectionInput, SetCollectionOutput } from "types/web-app";

export const setCollection = async (
  accessToken: string,
  input: SetCollectionInput
) => {
  try {
    const response = await fetchWithAuth("/collection/set", accessToken, {
      method: "POST",
      body: JSON.stringify(input),
    });
    const data = (await response.json()) as ServiceResponse<SetCollectionOutput>;
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
